import React from 'react';
import { FulfillmentOrdersListTemplate } from 'themes/modules/order/pages';
import { FulfillmentOrdersListViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new FulfillmentOrdersListViewStore(rootStore), 'fulfillmentOrdersListViewStore')
class FulfillmentOrdersList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<FulfillmentOrdersListTemplate
				{...this.props}
				viewStore ={this.props.fulfillmentOrdersListViewStore}
			/>
		);
	}
}

export default FulfillmentOrdersList;
